import {z} from "zod/v4";
import {Flexidate, TstzSpan} from "../tstzspan.ts";

export const TimelineTimePoint = z.object({
    at: Flexidate,
});
export type TimelineTimePoint = z.infer<typeof TimelineTimePoint>;
export const TimelineTimeSpan = z.object({
    span: TstzSpan,
});
export type TimelineTimeSpan = z.infer<typeof TimelineTimeSpan>;
export const TimelineTimeCoordinate
    = z.union([TimelineTimePoint, TimelineTimeSpan]);
export type TimelineTimeCoordinate = z.infer<typeof TimelineTimeCoordinate>;